import React, { useEffect } from "react";
import Ielts from "../media/ielts.jpg";
import Toefl from "../media/toefl.jpg";
import aptis from "../media/aptis.jpg";
import oopt from "../media/oopt.jpg";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ExamsCard from "components/Cursos/ExamsCard";
import Contactanos from "components/Contactanos/Contactanos";
import footerImg from "../media/grado-img.jpg";
import Header from "components/Header";
import "../index.css";

function ExamenesInternacionales() {
  
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const examsInfo = [{ color: "" }];
  return (
    <>
      <Header
        titulo="Certificaciones en Inglés"
        info="Prepárate con Brighton Centro de Inglés, el puente hacia tu futuro y alcanza tus metas."
        linkToSection="/certificaciones#acerca"
        botonDescripcion="Descubre más"
        img="https://brightonenglishcenter.edu.co/img/brighton-7.webp"
      />
      
      <section className="flex flex-row items-start m-32 gap-10" id="acerca">
        {/* <div className="w-1/2 bg-gray-600 h-[500px] m-5 rounded-30 rounded-tl-none overflow-hidden group shadow-xl">
          <img
            src="https://images.pexels.com/photos/221166/pexels-photo-221166.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt=""
            className="object-cover h-full w-full group-hover:scale-110 transition duration-300"
          />
        </div> */}
        <h2 className="w-1/2 text-7xl font-bold font-Bebas text-blue-4 text-right ">
          ¿Por qué certificar tu inglés?
        </h2>
        <div className="w-1/2">
          <p className="hyphens-none leading-relaxed text-2xl">
            Si piensas en estudiar en el exterior y vivir nuevas experiencias,
            conocer nuevas culturas y lugares maravillosos o estas buscando
            mejores oportunidades laborales en el extranjero, con{" "}
            <strong className="text-blue-4">Brighton Centro de Inglés</strong>{" "}
            puedes presentar los exámenes internacionales o nacionales de
            certificación más reconocidos como{" "}
            <strong className="text-blue-4">IELTS</strong>,{" "}
            <strong className="text-blue-4">TOEFL</strong>,{" "}
            <strong className="text-blue-4">APTIS</strong> y{" "}
            <strong className="text-blue-4">OOPT</strong>.
          </p>
        </div>
      </section>
      <section className=" flex flex-col m-5 gap-5">
        <ExamsCard
          color="#d15d77"
          title="IELTS."
          info="El examen IELTS (International English Language Testing System) es
              una prueba de certificación de inglés. Cuenta con dos versiones IELTS Academico y IELTS General, donde se evalúan las habilidades
              de comprensión auditiva, expresión oral, comprensión de lectura y
              expresión escrita de los candidatos."
          botonDescription="Conoce más"
          link="/certificaciones/ielts"
          classLink={`bg-white text-red-600 hover:bg-red-600 hover:text-white`}
          src={Ielts}
        />
        <ExamsCard
          color="#9297ff"
          class={`bg-cyan-300 flex-row-reverse rotate-1 rounded-tr-none`}
          title="TOEFL iBT."
          info="El examen TOEFL evalúa la habilidad de los hablantes no nativos de
              inglés para comprender y utilizar el idioma inglés en un contexto
              académico. Es ampliamente utilizado para admisión a universidades
              y programas académicos en países de habla inglesa."
          botonDescription="Conoce más"
          link="/certificaciones/toefl"
          classLink={`bg-white text-blue-6 hover:bg-blue-6 hover:text-white`}
          src={"https://brightonenglishcenter.edu.co/img/toefl-logo.jpg"}
        />
        <ExamsCard
          color="#acc81e"
          title="APTIS."
          info="APTIS es un examen Institucional, no Internacional, de Ingles para
              adultos (16+) diseñado por expertos del Concejo Británico para evaluar las cuatro
              habilidades: Escucha, Escritura, Lectura y Habla en conjunto con
              el componente de Gramática y Vocabulario. Cuenta con diferentes versiones como APTIS ADVANCED y APTIS GENERAL y cumplen con los
              requisitos del Marco Común Europeo. "
          botonDescription="Conoce más"
          link="/certificaciones/aptis"
          classLink={`bg-white text-lime-600 hover:bg-lime-600 hover:text-white`}
          src={aptis}
        />
        <ExamsCard
          color="#39bad0"
          title="OOPT."
          info="El Oxford Online Placement Test (OOPT) es una
              prueba de versión en computador de selección múltiple y adaptable
              al nivel de conocimiento en inglés del candidato que realiza la
              prueba. Este examen es recomendado para personas que necesiten
              medir su nivel de dominio del idioma inglés, para ascensos
              laborales o de carrera como la armada nacional."
          botonDescription="Conoce más"
          link="/certificaciones/oopt"
          classLink={`bg-white text-blue-500 hover:text-white hover:bg-blue-500`}
          src={oopt}
        />
      </section>
      <Contactanos
        classContainer={`flex-row-reverse`}
        titulo="¡Da el siguiente paso hacia tus metas!"
        classTitulo="text-blue-4 "
        texto={`Prepárate con Brighton y certifícate con los mejores resultados.`}
        link="https://wa.link/src8nq"
        boton="Comienza ahora"
        classBoton="bg-blue-4 text-white hover:bg-blue-6"
        img={footerImg}
      />
    </>
  );
}

export default ExamenesInternacionales;
